<template>
 <div>
    <div v-if="dblclickObj != null">
        <!-- 标题：{{dblclickObj.option}} -->
        <!-- <el-input v-model="dblclickObj.option.title.text" @change="rederChange(dblclickObj)" :key="'input' + dblclickObj.id"></el-input> -->
        <div style="display:flex;justify-content:space-between;margin-bottom:10px">
          <span>数据源:</span>
          <el-select clearable v-model="dblclickObj.config.dataset.value" placeholder="请选择" size="mini" @change="datasourceChange">
            <el-option
              v-for="item in dataSourceOption"
              :key="item.id"
              :label="item.dsName"
              :value="item.id">
            </el-option>
          </el-select>
        </div>
        <div style="display:flex;justify-content:space-between;margin-bottom:10px">
          <span>横坐标字段:</span>
          <el-select clearable v-model="dblclickObj.config.rowField.value" placeholder="请选择" size="mini" @change="abscissaChange">
            <el-option
              v-for="item in abscissaOption"
              :key="item.id"
              :label="item.showName"
              :value="item.fname">
            </el-option>
          </el-select>
        </div>

        <!-- 横坐标排序字段:
        <el-select v-model="sortField" placeholder="请选择" size="mini" @change="sortChange">
          <el-option
            v-for="item in abscissaOption"
            :key="item.id"
            :label="item.showName"
            :value="item.fname">
          </el-option>
        </el-select>
        <br>
        升序:
        <el-switch
          v-model="dblclickObj.config.sortField.asc"
          active-color="#13ce66"
          inactive-color="#ff4949">
        </el-switch>
        <br> -->
        <div style="display:flex;justify-content:space-between;margin-bottom:10px">
          <span>横坐标分组:</span> 
          <el-select
            clearable
            v-model="dblclickObj.config.groupByField.value"
            style="margin-left: 20px;"
            placeholder="请选择"
            size="mini"
            @change="rowGroupChange"
          >
            <el-option
              v-for="item in abscissaOption"
              :key="item.value"
              :label="item.showName"
              :value="item.fname">
            </el-option>
          </el-select>
        </div>
        <div style="display:flex;justify-content:space-between;margin-bottom:10px">
          <span>纵坐标字段:</span>
          <el-select clearable v-model="dblclickObj.config.colField.value" placeholder="请选择" size="mini" @change="colChange">
            <el-option
              v-for="item in abscissaOption"
              :key="item.id"
              :label="item.showName"
              :value="item.fname">
            </el-option>
          </el-select>
        </div>

        <!-- 横坐标: 
        <el-input v-for="(xAxis,index) in dblclickObj.option.dataset.source" 
          v-model="dblclickObj.option.dataset.source[index][0]" 
          placeholder="" 
          :key="'xAxis' + index + dblclickObj.id" 
          @change="rederChange(dblclickObj)">
        </el-input> -->
        <!-- 数据坐标值：
        <el-input v-for="(serie,index) in dblclickObj.option.dataset.source" 
            v-model="dblclickObj.option.dataset.source[index][1]" 
            placeholder="" 
            :key="'series' + index + dblclickObj.id"
            @change="rederChange(dblclickObj)">
        </el-input>
        <el-input v-for="(serie,index) in dblclickObj.option.dataset.source" 
            v-model="dblclickObj.option.dataset.source[index][2]" 
            placeholder="" 
            :key="'series' + index + dblclickObj.id" 
            @change="rederChange(dblclickObj)">
        </el-input>
        <el-input v-for="(serie,index) in dblclickObj.option.dataset.source" 
            v-model="dblclickObj.option.dataset.source[index][3]" 
            placeholder="" 
            :key="'series' + index + dblclickObj.id" 
            @change="rederChange(dblclickObj)">
        </el-input>
        <el-input v-for="(serie,index) in dblclickObj.option.dataset.source" 
            v-model="dblclickObj.option.dataset.source[index][4]" 
            placeholder="" 
            :key="'series' + index + dblclickObj.id" 
            @change="rederChange(dblclickObj)">
        </el-input> -->
    </div>
 </div>
</template>
<script>
import { getAbscissa } from "@/api/catConfig"
 export default {
   name: 'Y-lineHistogram',
   components: {
   },
   props: {
     dblclickObj: {
       type: Object,
       default: null,
     },
     dataSourceOption: {
       type:Array,
       default: []
     }
   },
   watch:{
     dblclickObj(val) {
      //  this.datasourceChange(val.config.dataset.value)
     }
   },
   data () {
     return {
       dataSource: '', 
       rowField: '',
       sortField: '',
       colField: '',
       groupByField:'',
       dataSources: [],
       abscissaOption: [], // 横坐标
     }
   },
   created () {
     this.init()
   },
   mounted () {
     // dblclickObj.config.rowField.value
   },
   methods: { 
     init() {
     },
     rederChange(histogram){
      // const findHistogram = this.histogramList.find((histogram) => histogram.id === this.dblclickIndex);
      // findHistogram.myChart.setOption(findHistogram.option);
      histogram.myChart.setOption(histogram.option);
    },
    // 选择数据源
    datasourceChange(val) {
      // 查横坐标相关接口
      getAbscissa({dsId: val}).then(res => {
          this.abscissaOption = res
      })
      // 赋值
      const item = this.dataSourceOption.filter(item => {
        return item.id == val
      })
      this.dblclickObj.config.dataset.value = item[0].id
      this.dblclickObj.config.dataset.label = item[0].dsName
    },
    // 选择横坐标字段
    abscissaChange(val) {
      const item = this.abscissaOption.filter(item => {
        return item.fname == val
      })
      this.dblclickObj.config.rowField.value = item[0].fname
      this.dblclickObj.config.rowField.label = item[0].showName
    },
    // 横坐标分组
    rowGroupChange(val) {
      const item = this.abscissaOption.filter(item => {
        return item.fname == val
      })
      this.dblclickObj.config.groupByField.value = item[0].fname
      this.dblclickObj.config.groupByField.label = item[0].showName
    },
    sortChange(val) {
      const item = this.abscissaOption.filter(item => {
        return item.fname == val
      })
      this.dblclickObj.config.sortField.value = item[0].fname
      this.dblclickObj.config.sortField.label = item[0].showName
    },
    colChange(val) {
      const item = this.abscissaOption.filter(item => {
        return item.fname == val
      })
      this.dblclickObj.config.colField.value = item[0].fname
      this.dblclickObj.config.colField.label = item[0].showName
    }
   },
 }
</script>

<style scoped lang='scss'>

 
</style>
